import { takeEvery } from "redux-saga/effects";
import createRequestSaga from "../../../common/saga/createRequestSaga";
import * as adminUserApi from "../api/adminUserApi";
import {
  SEARCH_ALL_USERS,
  APPROVAL_USER,
  UPDATE_USE_YN,
  DELETE_USER
} from "../actionCreators";

const searchAllUsers = createRequestSaga(
  SEARCH_ALL_USERS,
  adminUserApi.searchAllUsersApi
);
const approvalUser = createRequestSaga(
  APPROVAL_USER,
  adminUserApi.approvalUserApi
);
const updateUseYn = createRequestSaga(
  UPDATE_USE_YN,
  adminUserApi.updateUseYnApi
);
const deleteUser = createRequestSaga(
  DELETE_USER,
  adminUserApi.deleteUserApi
);

export function* userManagementSaga() {
  yield takeEvery(SEARCH_ALL_USERS, searchAllUsers);
  yield takeEvery(APPROVAL_USER, approvalUser);
  yield takeEvery(UPDATE_USE_YN, updateUseYn);
  yield takeEvery(DELETE_USER, deleteUser);
}
